import { auth, userService } from '../../../services';
import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions';

export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT_ERROR = 'UPDATE_ACCOUNT_ERROR';
export const UPDATE_ACCOUNT_REQUEST = 'UPDATE_ACCOUNT_REQUEST';
export const GET_ACCOUNT_INFO_REQUEST = 'GET_ACCOUNT_INFO_REQUEST';
export const GET_ACCOUNT_INFO_SUCCESS = 'GET_ACCOUNT_INFO_SUCCESS';
export const EDIT_ACCOUNT_INFO = 'EDIT_ACCOUNT_INFO';
export const CANCEL_EDIT_ACCOUNT_INFO = 'CANCEL_EDIT_ACCOUNT_INFO';
export const GET_MY_MEMBERSHIPS_REQUEST = 'GET_MY_MEMBERSHIPS_REQUEST';
export const GET_MY_MEMBERSHIPS_SUCCESS = 'GET_MY_MEMBERSHIPS_SUCCESS';
export const GET_MY_ORGANIZATIONS_REQUEST = 'GET_MY_ORGANIZATIONS_REQUEST';
export const GET_MY_ORGANIZATIONS_SUCCESS = 'GET_MY_ORGANIZATIONS_SUCCESS';
export const GET_USERS_INVITATIONS = 'GET_USERS_INVITATIONS';

export const INVITE_MEMBER = 'INVITE_MEMBER';
export const GET_INVOICES_REQUEST = 'GET_INVOICES_REQUEST';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_USERS_EVENTS = 'GET_USERS_EVENTS';
export const GET_USERS_COMMITTEES = 'GET_USERS_COMMITTEES';
export const GET_USER_COMMITTEE_DETAILS = 'GET_USER_COMMITTEE_DETAILS';
export const SELECTED_COMMITTEE = 'SELECTED_COMMITTEE';
export const SELECTED_MEMBER ="SELECTED_MEMBER";
export const SELECTED_ORGANIZATION = "SELECTED_ORGANIZATION";

export const CANCEL_MEMBERSHIP_SUBSCRIPTION_REQUEST = "CANCEL_MEMBERSHIP_SUBSCRIPTION_REQUEST";
export const CANCEL_MEMBERSHIP_SUBSCRIPTION_SUCCESS = "CANCEL_MEMBERSHIP_SUBSCRIPTION_SUCCESS";

export const GET_PAYMENT_REQUEST = 'GET_PAYMENT_REQUEST';
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS';
export const CLEAR_PAYMENT = 'CLEAR_PAYMENT';

const successColor =  "success";
const errorColor = "danger";
const warningColor = 'warning';

export const editAccount = (details) => {
	return (dispatch) => {
		dispatch({
			type: EDIT_ACCOUNT_INFO,
			payload: details
		});
	};
};

export const cancelEditAccount = (details) => {
	return (dispatch) => {
		dispatch({
			type: CANCEL_EDIT_ACCOUNT_INFO,
			payload: details
		});
	};
};

export const getAccountDetails = (email) => {
	return (dispatch) => {
		dispatch({
			type: GET_ACCOUNT_INFO_REQUEST,
			payload: email
		});
		userService.getUserProfile(email).then(({ data }) => {
			dispatch({
				type: GET_ACCOUNT_INFO_SUCCESS,
				payload: data
			});
		});
	};
};

export const updateAccount = (details) => {
	return (dispatch) => {
		dispatch({
			type: UPDATE_ACCOUNT_REQUEST,
			payload: details
		});
		var url = `${ROOT_API_URL}/users/updateprofile`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, details, options).then((res) => {
			if (res && res.data && res.data.isSuccess) {
				dispatch({
					type: UPDATE_ACCOUNT_SUCCESS,
					payload: details
				});
			} else {
				dispatch({
					type: UPDATE_ACCOUNT_ERROR,
					payload: res.data.message
				});
			}
		}).catch((err) => {
			dispatch({
				type: UPDATE_ACCOUNT_ERROR,
				payload: "Unable to update the Account"
			});
		});
	};
};

export const getMyMemberships = (id) => {
	return (dispatch) => {
		var url = `${ROOT_API_URL}/Users/GetMemberships?userId=${id}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_MY_MEMBERSHIPS_SUCCESS,
					payload: response.data
				});
			})
			.catch((err) => console.log(err));
	};
};


export const getMyOrganizations = (id) => {
	return (dispatch) => {
		dispatch({
			type: GET_MY_ORGANIZATIONS_REQUEST
		});
		var url = `${ROOT_API_URL}/organizations/getorganizations?userId=${id}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_MY_ORGANIZATIONS_SUCCESS,
					payload: response.data
				});
			})
			.catch((err) => console.log(err));
	};
};


export const getInvoices = (id) => {
    return (dispatch) => {

    dispatch({
        type: GET_INVOICES_REQUEST
    });

	var url = `${ROOT_API_URL}/stripepayment/GetInvoicesByUser?userId=${id}`;
	const options = { method: 'POST', headers: auth.authHeader() };
	axios.get(url, options).then((res) => {
        dispatch({
            type: GET_INVOICES_SUCCESS,
			payload: res.data
		});
	});
};
}
export const getUserInvitations = (id) => {
	return (dispatch) => {
		var url = `${ROOT_API_URL}/Users/GetUserInvitations?userId=${id}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios.get(url, options)
			.then((response) => {
			dispatch({
					type: GET_USERS_INVITATIONS,
					payload: response.data
				});
			})
			.catch((err) => console.log(err));
	};
};
export const getUserEvents = (id) => {
	return (dispatch) => {
		var url = `${ROOT_API_URL}/Events/GetEventsByUser?userId=${id}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios.get(url, options)
			.then((response) => {
			    dispatch({
					    type: GET_USERS_EVENTS,
					    payload: response.data
				    });
			    })
			.catch((err) => console.log(err));
	};
};
export const getUserCommittees = (id) => {
	return (dispatch) => {
		var url = `${ROOT_API_URL}/Users/GetUserCommittees?userId=${id}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios.get(url, options)
			.then((response) => {
			    dispatch({
					    type: GET_USERS_COMMITTEES,
					    payload: response.data
				    });
			    })
			.catch((err) => console.log(err));
	};
};
export const getUserCommitteeDetails = (id) => {
	return (dispatch) => {
		var url = `${ROOT_API_URL}/Users/GetUserCommitteeDetails?committeeMemberId=${id}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios.get(url, options)
			.then((response) => {
			    dispatch({
					    type: GET_USER_COMMITTEE_DETAILS,
					    payload: response.data
				    });
			    })
			.catch((err) => console.log(err));
	};
};

export function selectedCommittee(selectedCommitteeObject) {
    return function (dispatch) {
        dispatch({
            type: SELECTED_COMMITTEE,
            payload: selectedCommitteeObject
        })
    }
}

export function selectedMember(member) {
    return function (dispatch) {
        dispatch({
            type: SELECTED_MEMBER,
            payload: member
        })
    }
}

export function selectedOrganization(organization) {
    return function (dispatch) {
        dispatch({
            type: SELECTED_ORGANIZATION,
            payload: organization
        })
    }
}

export const cancelMembershipSubscription = (details) => {
	return (dispatch) => {
		dispatch({
			type: CANCEL_MEMBERSHIP_SUBSCRIPTION_REQUEST,
			payload: details
		});
		var url = `${ROOT_API_URL}/users/CancelMembershipSubscription`;
		const options = { method: 'POST', headers: auth.authHeader() };

		axios.post(url, details, options).then((res) => {
			if (res.data === true) {
				dispatch({
					type: CANCEL_MEMBERSHIP_SUBSCRIPTION_SUCCESS,
					payload: details
				});
			}
		})
		.catch((err) => console.log(err));
	};
};

export const getPaymentMethod = (membershipId) => {
	return (dispatch) => {
		dispatch({
			type: GET_PAYMENT_REQUEST,
			payload: membershipId
		});

		axios.get(
			`${ROOT_API_URL}/users/GetSubscriptionPaymentMethod?membershipId=${parseInt(membershipId)}`,
			{ headers: auth.authHeader() }
		).then((res) => {
			if (res && res.data) {
				dispatch({
					type: GET_PAYMENT_SUCCESS,
					payload: res.data.paymentMethod
				});
			}
		}).catch((err) => console.log(err));
	};
};

export const clearPayment = (details) => {
	return (dispatch) => {
		dispatch({
			type: CLEAR_PAYMENT
		});
	};
};